<template>
    <div v-loading="loadingContent">
        <el-tabs type="card">
              <el-tab-pane>
                <span slot="label">
                  <i class="fa fa-ban" aria-hidden="true"></i>
                  Parâmetros Gerais
                </span>

                <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
                  <div slot="form-footer"></div>
                </ed-form>
              </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>

    import Rest from 'common/rest'
    import EdForm from 'common/form'
    import FormItems from './_form/configuracao'

    export default {
        name:"esocial-configuracao",
        mixins:[Rest],
        components:{EdForm},
      	watch: {
          'formData.ativo'(){
            this.config.disabled.empresas = (this.formData.ativo == 0);
            this.config.disabled.data_inicio = (this.formData.ativo == 0);
            this.config.disabled.empresas_processar = (this.formData.ativo == 0);
          }
        },
        data () {
          return {
            response:{},
            config:{
              click:{
                empresas:this.getEmpresa,
                empresas_processar:this.getEmpresa,
                save:this.salvar
              },
              list:{
                empresas:[],
                empresas_processar:[]
              },
              loading:{
                empresas:false,
                empresas_processar:false,
                save:false
              },
              disabled:{
                empresas:true,
                empresas_processar:true,
                data_inicio:true
              }
            },
            formData:{
              id:0,
              ativo:0,
              empresas:[],
              data_inicio:this.toDate(),
              usuario:null,
              updated_at:null,
            },
            formItems:[],
            loadingContent:true,
          }
        },

        created(){
        },

        mounted() {
          this.getEsocialConfiguracao();
          //this.getEmpresa();

          this.formItems = FormItems;
        },

        methods:{

            getEmpresa: function(_search,_empresas){

              this.config.loading.empresas = true;
              this.config.loading.empresas_processar = true;
              this.config.list.empresas = [];
              this.config.list.empresas_processar = [];

                this.get('/empresa',{search:_search,pagination:10,filter:{empresas:_empresas}}).then((result)=>{

                  result = result[0];
                  this.config.loading.empresas = false;
                  this.config.loading.empresas_processar = false

                  if(result.status == 200){
                    this.config.list.empresas  = result.data.data;
                    this.config.list.empresas_processar  = result.data.data;
                  }
                });

            },

            getEsocialConfiguracao(){

              this.get('/esocial/configuracao').then((result)=>{

                result = result[0];

                this.loadingContent = false;
                this.config.list.empresas = [];
                this.config.list.empresas_processar = [];

                if(result.status == 200 && result.data){
                  this.formData = {
                    id: result.data.id,
                    ativo: result.data.ativo,
                    empresas:[],
                    empresas_processar:[],
                    data_inicio:(result.data.data_inicio ? this.toDate(result.data.data_inicio,true) : null),
                    usuario:result.data.usuario,
                    updated_at:this.toDate(result.updated_at),
                  }

                  for (let i = 0; i < result.data.empresas.length; i++) {
                    const element = result.data.empresas[i];

                    this.formData.empresas.push(element.id);
                    this.config.list.empresas.push(element);
                  }

                  
                  for (let i = 0; i < result.data.empresas_processar.length; i++) {
                    const element = result.data.empresas_processar[i];

                    this.formData.empresas_processar.push(element.id);
                    this.config.list.empresas_processar.push(element);
                  }
                }
              });
            },

            salvar(formName){

              this.config.loading.save = true;
              this.response = {};

              this.post('esocial/configuracao/editar',this.formData,false).then((result)=>{

                this.config.loading.save = false;

                result = result[0];

                this.response = result;

                if(result.status == 200){
                  this.edMsg('Dados atualizados com sucesso');
                  this.getEsocialConfiguracao();
                }
              });

            }

        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?64c2343a